import { render, staticRenderFns } from "./SalesPromoForm.vue?vue&type=template&id=19b80582&scoped=true&"
import script from "./SalesPromoForm.vue?vue&type=script&lang=js&"
export * from "./SalesPromoForm.vue?vue&type=script&lang=js&"
import style0 from "./SalesPromoForm.vue?vue&type=style&index=0&id=19b80582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b80582",
  null
  
)

export default component.exports